// Mock data for SiteOn website

export const companyInfo = {
  name: "SiteOn",
  tagline: "Transformamos ideias em presença digital",
  description: "Especialistas em desenvolvimento de sites para empresas que querem crescer online",
  email: "pedrolaudo.web@gmail.com",
  phone: "+351 911 892 361",
  logo: "https://customer-assets.emergentagent.com/job_online-growth-hub/artifacts/bg0cwqo6_prompt-para-logotipo-circular--instagram----siteon.jpg"
};

export const heroContent = {
  badge: "Agência de Design Digital",
  title: "Leve o Seu Negócio Para o Próximo Nível Online",
  subtitle: "Desenvolvemos sites profissionais que convertem visitantes em clientes. Desde a criação do zero até ao redesign completo, a SiteOn é o seu parceiro digital de confiança.",
  primaryCta: "Solicitar Orçamento Grátis",
  secondaryCta: "Saber Mais"
};

export const aboutContent = {
  badge: "Quem Somos",
  title: "A Sua Presença Online é a Nossa Missão",
  description: "Fundada com a visão de democratizar o acesso a websites de qualidade, a SiteOn nasceu para ajudar empresas de todos os tamanhos a estabelecer uma presença digital forte e profissional.",
  paragraphs: [
    "Com uma equipa dedicada de designers e programadores, combinamos criatividade com tecnologia de ponta para criar experiências digitais únicas.",
    "Acreditamos que cada negócio merece uma presença online que reflete a sua essência e valores. Por isso, trabalhamos lado a lado com os nossos clientes para entender as suas necessidades e superar as suas expectativas."
  ]
};

export const services = [
  {
    id: 1,
    icon: "Globe",
    title: "Desenvolvimento de Sites",
    description: "Sites modernos, responsivos e otimizados para conversão. Desde landing pages a plataformas complexas.",
    features: ["Design personalizado", "100% responsivo", "Carregamento rápido", "Painel de gestão"]
  },
  {
    id: 2,
    icon: "RefreshCw",
    title: "Redesign de Sites",
    description: "Transforme o seu site atual numa experiência moderna e eficaz que representa o seu negócio.",
    features: ["Análise do site atual", "Nova identidade visual", "Migração de conteúdo", "Melhoria de UX"]
  },
  {
    id: 3,
    icon: "Search",
    title: "Otimização SEO",
    description: "Apareça nos primeiros resultados do Google e atraia mais clientes qualificados para o seu negócio.",
    features: ["Pesquisa de palavras-chave", "SEO técnico", "Conteúdo otimizado", "Relatórios mensais"]
  },
  {
    id: 4,
    icon: "ShoppingCart",
    title: "E-commerce & Integrações",
    description: "Lojas online completas e integrações com redes sociais, pagamentos e sistemas de gestão.",
    features: ["Loja online completa", "Pagamentos seguros", "Gestão de stock", "Integração com redes"]
  }
];

export const benefits = [
  {
    id: 1,
    icon: "Award",
    title: "Presença Profissional",
    description: "Um site profissional transmite credibilidade e confiança aos seus potenciais clientes."
  },
  {
    id: 2,
    icon: "TrendingUp",
    title: "Aumento de Visibilidade",
    description: "Seja encontrado por quem procura os seus produtos ou serviços online."
  },
  {
    id: 3,
    icon: "Users",
    title: "Experiência Otimizada",
    description: "Sites intuitivos que guiam os visitantes até à conversão desejada."
  },
  {
    id: 4,
    icon: "Settings",
    title: "Soluções Personalizadas",
    description: "Cada projeto é único, desenvolvido de acordo com as necessidades do seu negócio."
  },
  {
    id: 5,
    icon: "Clock",
    title: "Disponível 24/7",
    description: "O seu site trabalha por si a qualquer hora, captando leads e vendas."
  },
  {
    id: 6,
    icon: "Shield",
    title: "Segurança Garantida",
    description: "Sites seguros com certificado SSL e proteção contra ameaças online."
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Restaurante Sabores",
    category: "Gastronomia",
    description: "Site com sistema de reservas online e menu digital interativo.",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80",
    tags: ["Website", "Reservas", "Menu Digital"]
  },
  {
    id: 2,
    title: "Clínica Vida Saudável",
    category: "Saúde",
    description: "Plataforma completa com agendamento de consultas e área do paciente.",
    image: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=600&q=80",
    tags: ["Website", "Agendamento", "Portal"]
  },
  {
    id: 3,
    title: "Loja TechStore",
    category: "E-commerce",
    description: "Loja online de tecnologia com integração completa de pagamentos.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80",
    tags: ["E-commerce", "Pagamentos", "Stock"]
  },
  {
    id: 4,
    title: "Imobiliária Premium",
    category: "Imobiliário",
    description: "Portal imobiliário com pesquisa avançada e tours virtuais.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80",
    tags: ["Portal", "Pesquisa", "Tour 360°"]
  },
  {
    id: 5,
    title: "Academia FitPlus",
    category: "Fitness",
    description: "Site com sistema de aulas online e área de membros.",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&q=80",
    tags: ["Website", "Membros", "Aulas Online"]
  },
  {
    id: 6,
    title: "Escritório Legal",
    category: "Advocacia",
    description: "Site institucional com formulário de contacto e blog jurídico.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80",
    tags: ["Institucional", "Blog", "Contacto"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Santos",
    role: "CEO, Restaurante Sabores",
    content: "A SiteOn transformou completamente a nossa presença online. As reservas aumentaram 40% no primeiro mês após o lançamento do novo site!",
    avatar: "MS"
  },
  {
    id: 2,
    name: "João Ferreira",
    role: "Diretor, Clínica Vida Saudável",
    content: "Profissionalismo e atenção ao detalhe. A equipa entendeu perfeitamente as nossas necessidades e entregou acima das expectativas.",
    avatar: "JF"
  },
  {
    id: 3,
    name: "Ana Costa",
    role: "Fundadora, TechStore",
    content: "O nosso e-commerce ficou incrível! A integração com os sistemas de pagamento foi perfeita e o suporte é sempre rápido.",
    avatar: "AC"
  }
];

export const faqItems = [
  {
    question: "Quanto tempo demora a criar um site?",
    answer: "O prazo varia de acordo com a complexidade do projeto. Um site institucional simples pode ficar pronto em 2-3 semanas, enquanto projetos mais complexos como e-commerce podem levar 4-8 semanas."
  },
  {
    question: "O site será responsivo para telemóvel?",
    answer: "Sim! Todos os nossos sites são desenvolvidos com design responsivo, garantindo uma experiência perfeita em qualquer dispositivo - desktop, tablet ou telemóvel."
  },
  {
    question: "Vocês oferecem manutenção após o lançamento?",
    answer: "Sim, oferecemos planos de manutenção mensais que incluem atualizações de segurança, backups, pequenas alterações de conteúdo e suporte técnico."
  },
  {
    question: "Posso atualizar o conteúdo do site sozinho?",
    answer: "Claro! Desenvolvemos os sites com painéis de gestão intuitivos que permitem atualizar textos, imagens e outros conteúdos de forma simples, sem precisar de conhecimentos técnicos."
  },
  {
    question: "Quais os métodos de pagamento aceites?",
    answer: "Aceitamos transferência bancária, cartão de crédito/débito e PayPal. Oferecemos também a possibilidade de pagamento em prestações para projetos maiores."
  }
];

export const ctaContent = {
  title: "Pronto Para Transformar o Seu Negócio Online?",
  subtitle: "Solicite um orçamento gratuito e sem compromisso. A nossa equipa está pronta para ajudar a criar a presença digital que o seu negócio merece.",
  buttonText: "Solicitar Orçamento Grátis",
  features: ["Orçamento gratuito", "Sem compromisso", "Resposta em 24h"]
};

export const footerLinks = {
  services: [
    { label: "Desenvolvimento de Sites", href: "#servicos" },
    { label: "Redesign de Sites", href: "#servicos" },
    { label: "Otimização SEO", href: "#servicos" },
    { label: "E-commerce", href: "#servicos" }
  ],
  company: [
    { label: "Quem Somos", href: "#quem-somos" },
    { label: "Testemunhos", href: "#testemunhos" },
    { label: "Contacto", href: "#contacto" }
  ],
  legal: [
    { label: "Política de Privacidade", href: "#" },
    { label: "Termos de Serviço", href: "#" },
    { label: "Cookies", href: "#" }
  ],
  social: {
    instagram: "https://www.instagram.com/siteon.design/"
  }
};
